import { render, staticRenderFns } from "./link-cell.vue?vue&type=template&id=b81a99c6&scoped=true"
import script from "./link-cell.vue?vue&type=script&lang=ts"
export * from "./link-cell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81a99c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b81a99c6')) {
      api.createRecord('b81a99c6', component.options)
    } else {
      api.reload('b81a99c6', component.options)
    }
    module.hot.accept("./link-cell.vue?vue&type=template&id=b81a99c6&scoped=true", function () {
      api.rerender('b81a99c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/benchmarking-table/cell-types/link-cell.vue"
export default component.exports